<template>
    <b-nav-item-dropdown class="QuickCartDropdown" right data-test="cart-dropdown">
        <span slot="text">
            <span class="hide-collapsed">
                {{ cart ? cart.name : 'Auncun panier' }}
            </span>
            <span class="d-inline-block position-relative" :class="{ 'pr-sm-2':updatedSize }">
                <slot name="cart-icon"></slot>
                <template v-if="updatedSize">
                    <span class="badge nav-badge nav-badge--cart align-top border-white border" data-test="cart-size">{{ updatedSize }}</span>
                </template>
            </span>
        </span>
        <div class="py-2">
            <div class="px-3" style="font-size: .875rem">
                {{ warehouse.name }}<template v-if="rentPeriod">, {{ rentPeriod }}</template>
            </div>
            <hr class="mt-2 mb-1">
            <div class="px-3" style="font-size: .875rem">Manifestation « {{ show.name }} »</div>
            <hr class="my-1">
            <div class="px-3 mt-3">
                <template v-if="updatedSize">
                    <strong>
                        {{ updatedSize }} article{{ updatedSize>1 ? 's' : '' }}<template v-if="isValid">&nbsp; – &nbsp;<span v-html="formatPrice(updatedTotal)"></span></template>
                    </strong>
                </template>
                <template v-else>
                    <div class="alert alert-info mb-0 py-1 px-2">le panier est vide</div>
                </template>
                <div class="mt-3">
                    <a class="btn btn-primary py-1 px-2 text-left" :href="cartUrl" style="font-size: 1.25rem" data-test="goto-cart">afficher</a>
                </div>
            </div>
        </div>
    </b-nav-item-dropdown>
</template>

<script>
    import { BNavItemDropdown } from 'bootstrap-vue';
    import { Prices } from "../mixins";

    export default {
        mixins: [Prices],
        components: {
            BNavItemDropdown,
        },
        props: {
            cart: Object, // { name }
            warehouse: Object, // { name }
            show: Object, // { name }
            size: Number,
            total: Number,
            rentPeriod: String,
            cartUrl: String,
            endpoint: String,
            isValid: Boolean
        },
        computed: {
            updatedSize() {
                return this.$store.state.cart.size || this.size;
            },
            updatedTotal() {
                return this.$store.state.cart.total || this.total;
            },
        }
    }
</script>